import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const PageHero = ({ overline, lines, image, description }) => (
  <section data-testid="page-hero" className="relative h-[56vh] min-h-[420px] flex items-end overflow-hidden">
    <motion.img
      src={image}
      alt=""
      initial={{ scale: 1.08 }}
      animate={{ scale: 1 }}
      transition={{ duration: 2.2, ease }}
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-black/40" />
    <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-forest-deep/80 to-transparent" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 pb-14 md:pb-20 w-full">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.7, ease }}
        className="text-xs tracking-[0.3em] uppercase font-semibold text-gold"
      >
        {overline}
      </motion.p>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl text-ivory tracking-tight leading-[1.05]">
        {lines.map((line, i) => (
          <span key={line} className="block overflow-hidden pb-1">
            <motion.span
              className="block"
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ delay: 0.45 + i * 0.14, duration: 0.9, ease }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </h1>
      {description && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.8 }}
          className="mt-5 max-w-xl text-ivory/80 text-base md:text-lg leading-relaxed"
        >
          {description}
        </motion.p>
      )}
    </div>
  </section>
);
